import { useEffect, useRef, useState } from "react";
import api from "../lib/api";

export default function VerifyEmail() {
  const [status, setStatus] = useState("verifying");
  const [message, setMessage] = useState("");
  const [token, setToken] = useState(null);
  const hasVerifiedRequest = useRef(false);

  useEffect(() => {
    const getTokenFromUrl = () => {
      try {
        const href = window.location.href || "";
        const queryIndex = href.indexOf("?");
        if (queryIndex === -1) return null;
        return new URLSearchParams(href.slice(queryIndex + 1)).get("token");
      } catch {
        return null;
      }
    };

    const parsedToken = getTokenFromUrl();
    setToken(parsedToken);

    console.debug("VerifyEmail URL parse", {
      href: window.location.href,
      search: window.location.search,
      hash: window.location.hash,
      parsedToken,
    });

    if (!parsedToken) {
      setStatus("invalid");
      setMessage("No verification token found in the URL.");
      return;
    }

    if (hasVerifiedRequest.current) {
      return;
    }
    hasVerifiedRequest.current = true;

    api
      .get(`/users/verify`, { params: { token: parsedToken } })
      .then((response) => {
        console.debug("VerifyEmail success response", response.data);
        setStatus("success");
        setTimeout(() => {
          window.location.href = `${window.location.origin}/#/signin?verified=true`;
        }, 2000);
      })
      .catch((error) => {
        console.error(
          "VerifyEmail request failed:",
          error.response?.data || error,
        );
        setStatus("error");
        setMessage(
          error.response?.data?.message ||
            error.response?.data?.error ||
            "Invalid or expired verification link.",
        );
      });
  }, []);

  return (
    <div>
      {status === "verifying" && <p>Verifying your email...</p>}
      {status === "success" && (
        <p>✅ Email verified! Redirecting to sign in...</p>
      )}
      {status === "error" && (
        <p>❌ Verification failed: {message || "Invalid or expired link."}</p>
      )}
      {status === "invalid" && <p>❌ {message || "No token provided."}</p>}
      {token && <p className="mt-4 text-sm text-slate-400">Token: {token}</p>}
    </div>
  );
}
